import { AssessmentNodeStatusEnum, AssessmentNodeTypeEnum, AssessmentStatusEnum } from "apis/backoffice-api/data-contracts";


export enum assessmentSkillMode {
  NEW = 'NEW',
  EDIT = 'EDIT',
  EDITED = 'EDITED'
}

export interface locationAssessmentAppraiseesState {
  mode?: assessmentSkillMode
  assessmentId: string,
  assessmentStatus: AssessmentStatusEnum,
  assessmentNodes: assessmentNodes[]
}

export interface assessmentNodes {
  assessmentNodeId: string
  assessmentId: string
  appraiserAssessmentParticipantId: string
  appraiserAssessmentParticipant: {
    assessmentParticipantId: string
    assessmentId: string
    resourceId: string
  }
  appraiseeAssessmentParticipantId: string
  appraiseeAssessmentParticipant: {
    assessmentParticipantId: string
    assessmentId: string
    resourceId: string
  },
  type: AssessmentNodeTypeEnum
  status: AssessmentNodeStatusEnum
}

export interface locationAssessmentNodesState {
  assessmentNodes: assessmentNodes[]
}
